import { connect } from 'react-redux';
import FxMigrationAlert from './fx_migration_alert';

type UserSlice = {
  user?: unknown;
};

type FxMigrationRootState = {
  user?: UserSlice;
};

const mapStateToProps = (state: FxMigrationRootState) => ({
  user: state.user?.user
});

export default connect(mapStateToProps, {})(FxMigrationAlert);
